import { client } from 'services/http';
import { fetchError, fetchStart, fetchSuccess } from './Common';
import { DELETE_ARTIST, GET_ARTISTS_LIST, SET_ARTIST_FILTER_TYPE } from '@jumbo/constants/ActionTypes';

//For setting Filtertype
export const setArtistFilterType = filterType => {
  return {
    type: SET_ARTIST_FILTER_TYPE,
    payload: filterType,
  };
};

export const getArtistsList = params => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v1/artists/`, { params: { ...params } })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_ARTISTS_LIST, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError('Something went wrong'));
      });
  };
};

export const deleteArtist = id => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .delete(`/share/v1/artists/${id}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: DELETE_ARTIST, payload: id });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response.data.error[0]));
      });
  };
};
